import { app } from '../../../../../../app';
import { Controller } from './add-sms-user.controller';

app.component('companyUserDirectoriesSaaspassUsersSmsUsersAdd', {
    bindings: {companyId: '<'},
    controller: Controller,
    templateUrl: require('./add-sms-user.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/sms-users/add/add-sms-user.component.js